// src/component/dashboard/VerticalSelector.jsx
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  clearFormError,
  addSelectedVertical,
  removeSelectedVertical
} from '../../store/slices/modalsSlice';

const verticals = ['Casino', 'Sports Betting', 'Poker', 'Lottery', 'Bingo', 'Sweepstake', 'Crypto'];

const VerticalSelector = () => {
  const dispatch = useDispatch();
  const { addProjectForm } = useSelector(state => state.modals);
  const { selectedVerticals, errors } = addProjectForm;

  const handleVerticalSelect = (vertical) => {
    if (!selectedVerticals.includes(vertical)) {
      dispatch(addSelectedVertical(vertical));
      if (errors.verticals) {
        dispatch(clearFormError('verticals'));
      }
    }
  };

  const handleRemoveVertical = (vertical) => {
    dispatch(removeSelectedVertical(vertical));
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <label className="block text-sm font-semibold text-gray-700 dark:text-slate-300 flex items-center gap-1">
          <svg className="w-4 h-4 text-gray-500 dark:text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
          </svg>
          Vertical *
        </label>
        {selectedVerticals.length > 0 && (
          <span className="text-xs font-medium text-gray-500 dark:text-slate-400">
            {selectedVerticals.length} selected
          </span>
        )}
      </div>
      <select
        onChange={(e) => {
          if (e.target.value) {
            handleVerticalSelect(e.target.value);
            e.target.value = '';
          }
        }}
        className={`w-full px-4 py-2.5 border rounded-xl focus:outline-none focus:ring-2 transition-all dark:bg-slate-800 dark:text-slate-100 dark:placeholder-slate-500 ${
          errors.verticals
            ? 'border-red-300 dark:border-red-600 focus:ring-red-500 focus:border-red-300 bg-red-50 dark:bg-red-900/20'
            : 'border-gray-200 dark:border-slate-600 focus:ring-blue-500 focus:border-blue-500 hover:border-gray-300 dark:hover:border-slate-500'
        } bg-white cursor-pointer`}
      >
        <option value="" className="dark:bg-slate-800 dark:text-slate-100">Select vertical...</option>
        {verticals.map((vertical) => (
          <option
            key={vertical}
            value={vertical}
            disabled={selectedVerticals.includes(vertical)}
            className="dark:bg-slate-800 dark:text-slate-100 disabled:text-gray-400 dark:disabled:text-slate-500"
          >
            {selectedVerticals.includes(vertical) ? `✓ ${vertical}` : vertical}
          </option>
        ))}
      </select>

      {errors.verticals && (
        <p className="mt-2 text-sm text-red-600 dark:text-red-400 flex items-center gap-1">
          <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
          </svg>
          {errors.verticals}
        </p>
      )}

      {selectedVerticals.length > 0 && (
        <div className="mt-3 flex flex-wrap gap-2">
          {selectedVerticals.map((vertical) => (
            <span
              key={vertical}
              className="inline-flex items-center gap-2 px-3 py-1.5 bg-gradient-to-r from-purple-50 to-purple-100 dark:from-purple-900/30 dark:to-purple-800/30 border border-purple-200 dark:border-purple-700 text-purple-700 dark:text-purple-300 rounded-full text-sm font-medium shadow-sm hover:shadow transition-shadow"
            >
              <svg className="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
              </svg>
              <span>{vertical}</span>
              <button
                onClick={() => handleRemoveVertical(vertical)}
                className="ml-0.5 -mr-1 w-5 h-5 flex items-center justify-center rounded-full hover:bg-purple-200 dark:hover:bg-purple-700 text-purple-600 dark:text-purple-400 hover:text-purple-800 dark:hover:text-purple-200 transition-colors"
                aria-label={`Remove ${vertical}`}
              >
                <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default VerticalSelector;